import { RouterStateSerializer } from '@ngrx/router-store';
import { RouterStateSnapshot, Params } from '@angular/router';
import { LoadDataRequest, LoadDataRequestAtlas } from '../global/interfaces';
import { isNullOrUndefined } from 'util';
import * as moment from 'moment';
import { Actions, ButtonVariants } from 'atlas-cdk';
import { AlertService } from 'atlas-alert';
// import { ToasterService } from '../features/toaster/toaster.service';

/**
 * The RouterStateSerializer takes the current RouterStateSnapshot
 * and returns any pertinent information needed. The snapshot contains
 * all information about the state of the router at the given point in time.
 * The entire snapshot is complex and not always needed. In this case, you only
 * need the URL and query parameters from the snapshot in the store. Other items could be
 * returned such as route parameters and static route data.
 */


export const amountOfTransactionsForPDFExport = '9999999';

export interface RouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
}

export class CustomRouterStateSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const { url, root: { queryParams } } = routerState,
      { params } = route;

    // Only return an object including the URL, params and query params
    // instead of the entire snapshot
    return { url, params, queryParams };
  }
}

export const createQuery = ({ name, filter, pagination, sort, status, country, accountName, accountNumber }: LoadDataRequestAtlas): string => {
  // querying by attributes

  let query = '?';
  if (country) {
    query += `country=${country}&`;
  }
  if (filter) {
    Object.keys(filter).forEach(filterKey => {
      const filterValue = filter[filterKey];
      if (filterValue) {
        query += `${filterKey}=${filterValue}&`;
      }
    });
  }

  if (name) {
    query += `name=${name}&`;
  }
  if (accountName) {
    query += `accountName=${accountName}&`;
  }
  if (accountNumber) {
    query += `accountNumber=${accountNumber}&`;
  }

  // paging query
  if (pagination) {
    const page = pagination.page;
    query += `page=${page}&size=${pagination.itemsByPage}&`;
  }

  // sort query
  if (sort && sort.column) {
    query += `sort=${sort.column}&direction=${!sort.reverse ? 'asc' : 'desc'}`;
  }

  if (status) {
    query += `status=${status}&`;
  }

  return query;
};

export const createQueryAtlas = ({ name, filter, pagination, sort, status, country, accountName, accountNumber }: LoadDataRequestAtlas): string => {

  // querying by attributes
  let query = '?';
  if (country) {
    query += `country=${country}&`;
  }
  if (filter) {
    Object.keys(filter).forEach(filterKey => {
      const filterValue = filter[filterKey];
      if (filterValue) {
        query += `${filterKey}=${filterValue}&`;
      }
    });
  }

  if (name) {
    query += `name=${name}&`;
  }
  if (accountName) {
    query += `accountName=${accountName}&`;
  }
  if (accountNumber) {
    query += `accountNumber=${accountNumber}&`;
  }

  // paging query
  if (pagination) {
    // const page = pagination.page / pagination.itemsByPage + 1;
    const page = pagination.page;

    query += `page=${page}&size=${pagination.itemsByPage}&`;
  }

  // sort query
  if (sort && sort.column) {
    query += `sort=${sort.column}&direction=${!sort.reverse ? 'asc' : 'desc'}`;
  }

  if (status) {
    query += `status=${status}&`;
  }
  return query;
};

export const createQueryAtlasClients = ({ name, filter, pagination, sort, status, country, accountName, accountNumber }: LoadDataRequestAtlas): string => {

  // querying by attributes
  let query = '?';
  if (country) {
    query += `country=${country}&`;
  }
  if (filter) {
    Object.keys(filter).forEach(filterKey => {
      const filterValue = filter[filterKey];
      if (filterValue) {
        query += `${filterKey}=${filterValue}&`;
      }
    });
  }

  if (name) {
    query += `name=${name}&`;
  }
  if (accountName) {
    query += `accountName=${accountName}&`;
  }
  if (accountNumber) {
    query += `accountNumber=${accountNumber}&`;
  }

  // paging query
  if (pagination) {
    // const page = pagination.page / pagination.itemsByPage + 1;
    const page = pagination.page;

    query += `page=${page}&size=100&`;
  }

  // sort query
  if (sort && sort.column) {
    query += `sort=${sort.column}&direction=${!sort.reverse ? 'asc' : 'desc'}`;
  }

  if (status) {
    query += `status=${status}&`;
  }
  return query;
};

export const createPostQuery = (payload: LoadDataRequestAtlas) => {
  const body: any = {};

  Object.keys(payload).forEach(key => {
    if (key === 'sort') {
      body['sort'] = payload.sort.column;
      body['direction'] = !payload.sort.reverse ? 'asc' : 'desc';
    } else if (key === 'pagination') {
      //body['page'] = payload.pagination.offset / payload.pagination.limit + 1;
      body['page'] = payload.pagination.page;
      body['size'] = payload.pagination.itemsByPage;
    } else if (key === 'filter') {
      Object.entries(payload[key]).forEach(([key, value]) => {
        body[key] = value;
      });
    } else {
      body[key] = payload[key];
    }
  });

  return body;
};

export function buildQuery(payload: LoadDataRequest): string {
  const parameters = [];

  Object.keys(payload).forEach(key => {
    if (key === 'sort') {
      parameters.push(`sort=${payload.sort.column}`);
      parameters.push(`direction=${!payload.sort.reverse ? 'asc' : 'desc'}`);
    } else if (key === 'pagination') {
      const page = payload.pagination.page;
      parameters.push(`page=${page}`);
      parameters.push(`size=${payload.pagination.itemsByPage}`);
    } else {
      parameters.push(`${key}=${payload[key]}`);
    }
  });

  return `?${parameters.join('&')}`;
}

export function convertDateForIE(date: string): string {
  const dateParts = date.split(' '),
    months = ['', 'JANUARY',
      'FEBRUARY',
      'MARCH',
      'APRIL',
      'MAY',
      'JUNE',
      'JULY',
      'AUGUST',
      'SEPTEMBER',
      'OCTOBER',
      'NOVEMBER',
      'DECEMBER'];
  let month: any = months.indexOf(dateParts[0]);
  month = (month < 10 ? '0' + month : month);

  return `${dateParts[1]}-${month}`;
}

export function breakSentenceByWhitespaces(sentence: string, nth = 3): string {
  const split = sentence.split(' ');
  if (split.length <= nth) {
    return sentence;
  }

  let newSentence = '';

  for (let i = 0; i < split.length; i++) {
    newSentence += split[i] + ' ';

    if (i > 0 && (i + 1) % nth === 0) {
      newSentence += '<br>';
    }
  }

  return newSentence;
}
export function sortAlphabetically(key, order = 'asc') {
  return function innerSort(value1, value2) {
    if (!value1.hasOwnProperty(key) || !value2.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }
    const sortedResult = value1[key].localeCompare(value2[key]);
    return (
      (order === 'desc') ? (sortedResult * -1) : sortedResult
    );
  };
}

export function printTermsAndConditions(termsAndConditionDivId) {
  const termsAndConditionContents = document.getElementById(termsAndConditionDivId).innerHTML,
    windowPrint = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
  windowPrint.document.write(termsAndConditionContents);
  windowPrint.document.close();
  windowPrint.focus();
  windowPrint.print();
  windowPrint.close();
}

export function capitalizeFirstChar(value) {
  if (!isNullOrUndefined(value) && value.length > 0) {
    return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
  } else {
    return value;
  }
}

export function getMinMaxValues(fundData, benchmarkData = [], propName: string | number = 'y') {
  let maxFundValue = 0,
    minFundValue = 0,
    maxBenchmarkValue = 0,
    minBenchmarkValue = 0;

  fundData.forEach(fundValue => {
    if (!isNaN(fundValue[propName])) {
      maxFundValue = (fundValue[propName] < maxFundValue)
        ? maxFundValue : fundValue[propName];
      minFundValue = (fundValue[propName] < minFundValue)
        ? fundValue[propName] : minFundValue;
    }
  });

  benchmarkData.forEach(benchValue => {
    if (!isNaN(benchValue[propName])) {
      maxBenchmarkValue = (benchValue[propName] < maxBenchmarkValue)
        ? maxBenchmarkValue : benchValue[propName];
      minBenchmarkValue = (benchValue[propName] < minBenchmarkValue)
        ? benchValue[propName] : minBenchmarkValue;
    }
  });

  return {
    max: (maxFundValue > maxBenchmarkValue) ? maxFundValue : maxBenchmarkValue,
    min: (minFundValue > minBenchmarkValue) ? minBenchmarkValue : minFundValue
  };
}


export function getTickPositions(max: any, min: any): number[] {
  if ((!isNullOrUndefined(min) && !isNullOrUndefined(max)) && (max !== 0 || min !== 0)) {
    const positions = [];

    let maxLength = (max > 0 && min >= 0) ? max : ((min < 0 && max <= 0) ? min : (max - min));
    maxLength = Math.abs(maxLength);
    const multipleFactor = (maxLength < 20)
      ? 1 : ((maxLength > 20 && maxLength < 100)
        ? 2 : 5),
      increment = (Math.floor(((maxLength) / 10) / 5) + 1) === 0
        ? 1 : (Math.floor(((maxLength) / 10) / 5) + 1) * multipleFactor;

    let negativeRange = parseInt((min / increment).toString(), 10);
    negativeRange = negativeRange > 0 ? negativeRange + 1 : negativeRange - 3;
    let postiveRange = parseInt((max / increment).toString(), 10);
    postiveRange = ((postiveRange > 0)
      || (postiveRange === 0 && max > 0)) ? postiveRange + 2 : postiveRange - 1;
    const startCounter = (max > 0 && min >= 0) || (min < 0 && max <= 0) ? 0 : negativeRange,
      caseType = (max > 0 && min >= 0) ? 1 : ((min < 0 && max <= 0) ? 2 : 0);

    switch (caseType) {
      case 0:
        // min is -ve and max is +ve
        for (let tick = negativeRange; tick <= postiveRange; tick++) {
          positions.push(tick * increment);
        }
        break;
      case 1:
        // both min and max +ve
        for (let tick = startCounter; tick <= postiveRange; tick++) {
          positions.push(tick * increment);
        }
        break;
      case 2:
        // both min and max -ve
        for (let tick = negativeRange; tick <= startCounter; tick++) {
          /* eslint-disable */
          tick === 0 ? positions.push(0) : positions.push(tick * increment);
        }
        break;
    }
    return positions;
  }
}

export function getCurrentYear() {
  return moment().format('YYYY');
}


// export function showToast(toasterService: ToasterService, message: string, action: string = 'success') {
//   const errmsg = { errmsgs: message, action: action };
//   toasterService.sendEventToaster(errmsg);
// }
